"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabeledField = LabeledField;
var jsx_runtime_1 = require("react/jsx-runtime");
var text_component_1 = require("./text-component");
function LabeledField(props) {
    var label = props.label, className = props.className, children = props.children;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1.5 ".concat(className !== null && className !== void 0 ? className : ""), children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", weight: "medium", color: "dark-gray-1", label: label }), children] }));
}
